import { useFeatureEntitlements } from '@frontegg/react';
import { AppNavMenu } from '..';
import { CheckSquareBroken } from '@insight-health-ai/roseate/icons';

export const useTaskNavMenus = (): AppNavMenu[] => {
  const { isEntitled: isTasksModuleEntitled } = useFeatureEntitlements('tasks');

  if (isTasksModuleEntitled) {
    return [
      {
        path: '/tasks',
        title: 'Tasks',
        icon: <CheckSquareBroken />,
      },
    ];
  }

  return [];
};
